import React from "react";
import { AuthenticationManager } from "../../../common/AuthenticationManager";
import { GenericMessages } from "../../../common/Constants";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BreadCrumb } from "../../common/BreadCrumb";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { CancelPreviewButton } from "../common/CancelPreviewButton";
import { CardMode } from "../common/CardMode";
import { ContestDetailCard } from "./cards/ContestDetailCard";
import { ContestPreview } from "./preview/ContestPreview";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";

export class ContestCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: CardMode.Create,
      generalInfo: null,
      generalInfoValidations: [],
      redirect: false,
      showCancelDialog: false,
      showConfirmDialog: false,
      showPreview: false,
    };
  }

  isValidated() {
    const { generalInfoValidations } = this.state;
    return generalInfoValidations.every((val) => val.isValid);
  }

  onGeneralInfoModelChange = (model) => {
    const contestStartTime = StringHelper.toDateTimeString(
      model.contestStartTimeStr
    );
    const contestEndTime = StringHelper.toDateTimeString(
      model.contestEndTimeStr
    );
    const displayStartTime = StringHelper.toDateTimeString(
      model.displayStartTimeStr
    );
    const displayEndTime = StringHelper.toDateTimeString(
      model.displayEndTimeStr
    );
    const category = StringHelper.toNumber(model.category, 0);
    const weightDisplay = StringHelper.toNumber(model.weightDisplay, 0);
    const newModel = Object.assign(model, {
      category,
      contestEndTime,
      contestStartTime,
      displayStartTime,
      displayEndTime,
      weightDisplay,
    });
    this.setState({ generalInfo: newModel });
  };

  onGeneralInfoValidationsChange = (validations) => {
    this.setState({ generalInfoValidations: validations });
  };

  onHideCancelDialog = () => {
    this.setState({ showCancelDialog: false });
  };

  onHideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  onHidePreview = () => {
    this.setState({ showPreview: false });
  };

  onProceedCancelDialog = () => {
    this.redirectToListingPage();
  };

  onShowCancelDialog = () => {
    this.setState({ showCancelDialog: true });
  };

  onShowConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showConfirmDialog: true });
  };

  onShowPreview = () => {
    this.setState({ showPreview: true });
  };

  onProceedConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true, showConfirmDialog: false });
      return;
    }
    const { generalInfo } = this.state;
    const request = Object.assign(
      {},
      generalInfo
    );
    RestClient.sendPostRequest(
      "/api/v1/contests/",
      request,
      () => {
        const successMessage =
          GenericMessages.CreationSuccessfulMessage("Contest");
        toast.success(successMessage);
        this.setState({
          redirect: true,
          showConfirmDialog: false,
        });
        this.redirectToListingPage();
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
        this.setState({
          showConfirmDialog: false,
        });
      }
    );
  };

  redirectToListingPage(additionalParameter) {
    this.props.history.push(`/contests/${additionalParameter ?? ""}`);
  }

  getNavigationSettings = () => {
    return new NavigationSettings({
      rootModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      parentModule: new NavigationItem({
        identifier: "contests",
        name: "Contests",
      }),
      activeModule: new NavigationItem({
        identifier: "contest-creation",
        name: "Create Contest",
      }),
    });
  };

  render() {
    const {
      cardMode,
      isSubmit,
      generalInfo,
      showCancelDialog,
      showConfirmDialog,
      showPreview,
    } = this.state;
    if (showPreview) {
      const previewModel = Object.assign(
        {},
        generalInfo
      );
      return (
        <>
          <CancelPreviewButton onClick={this.onHidePreview} />
          <ContestPreview contest={previewModel} />
        </>
      );
    }
    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <ContestDetailCard
                  cardMode={cardMode}
                  model={generalInfo}
                  isSubmit={isSubmit}
                  onModelChange={this.onGeneralInfoModelChange}
                  onValidationsChange={this.onGeneralInfoValidationsChange}
                />
              </div>
            </div>
            <div className="d-flex flex-row justify-content-end">
              <button
                className="btn btn-outline-secondary mr-1"
                onClick={this.onShowPreview}
              >
                Preview
              </button>
              <button
                className="btn btn-success mr-1"
                onClick={this.onShowConfirmDialog}
              >
                Create
              </button>
              <button
                className="btn btn-danger"
                onClick={this.onShowCancelDialog}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
          <ConfirmDialog
            visible={showCancelDialog}
            onCancel={this.onHideCancelDialog}
            onProceed={this.onProceedCancelDialog}
            message={GenericMessages.CancelCreationDialogMessage("contest")}
            title={GenericMessages.CancelCreationDialogTitle("contest")}
          />
          <ConfirmDialog
            visible={showConfirmDialog}
            onCancel={this.onHideConfirmDialog}
            onProceed={this.onProceedConfirmDialog}
            message={GenericMessages.ConfirmCreationDialogMessage("contest")}
            title={GenericMessages.ConfirmCreationDialogTitle("contest")}
          />
      </div>
    );
  }
}
